module.exports = __webpack_public_path__ + "static/JannonText-Italic-982b6acd083524369a926b9203b807d4.woff";